var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStorygamePlayCircle = function SvgIconStorygamePlayCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 36.667,
    fill: "#000",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 28.564c0-1.548 1.8-2.442 3.084-1.532L51.7 38.468a1.868 1.868 0 0 1 0 3.064L35.584 52.967c-1.284.911-3.084.017-3.084-1.532v-22.87Z",
    fill: "#fff"
  })));
};
export default SvgIconStorygamePlayCircle;